import { BaSeTag, BaSeTheme } from '@base/react';
import * as React from 'react';

export const Tag = ({ tagKey, label, icon, action }) => (
  <BaSeTag
    icon={icon}
    label={label}
    color={ColorMapper[tagKey].color}
    type="secondary"
    onClick={action}
    size="medium"
  />
);

const ColorMapper = {
  done: {
    color: BaSeTheme.colors.institucionais.azulSebrae30,
  },
  check: {
    color: BaSeTheme.colors.feedbackInterface.sucesso45,
  },
  default: {
    color: BaSeTheme.colors.institucionais.cinzaSebrae60,
  },
  pending: {
    color: BaSeTheme.colors.gestao.amarelo63,
  },
  nao_apto: {
    color: BaSeTheme.colors.feedbackInterface.erro35,
  },
  error: {
    color: BaSeTheme.colors.feedbackInterface.erro35,
  },
};
